import { Job } from "../../../model/Job";
import {
  ContentContainer,
  FlexRow,
  ProfileTextContainerLargeText,
  ReadOnlyContainer,
} from "../../../styles/backend/container";
import {
  BackendGridContainer,
  BackendGridItem,
} from "../../../styles/backend/grid";
import { ReadOnlyEditor } from "../../global/ReadOnlyEditor";

interface Props {
  job: Job;
  largeHeadline?: boolean;
}

export const JobDescriptionRead = ({ job, largeHeadline = false }: Props) => {
  return job?.description != null && job?.description?.length > 0 ? (
    <BackendGridContainer className="container-margin">
      <BackendGridItem span={12}>
        <ContentContainer cols={1} largeHeadline={largeHeadline}>
          <ProfileTextContainerLargeText>
            <div>
              <div className="container-headline">
                <strong>Wofür wir suchen</strong>
              </div>
              <ReadOnlyContainer>
                <FlexRow>
                  {job?.description != null && job?.description.length > 20 && (
                    <ReadOnlyEditor storedStateRaw={job.description} />
                  )}
                </FlexRow>
              </ReadOnlyContainer>
            </div>
          </ProfileTextContainerLargeText>
        </ContentContainer>
      </BackendGridItem>
    </BackendGridContainer>
  ) : (
    <></>
  );
};
